class Workspace {
  constructor(id, name, description, version, startDate, endDate, forSimulator, deployable, typeLocks) {
    this.id = id;
    this.name = name || 'Unknown';
    this.description = description || '';
    this.version = version || 'Undefined';
    this.startDate = startDate || '';
    this.endDate = endDate || '';
    this.forSimulator = forSimulator || false;
    this.deployable = deployable || false;
    this.typeLocks = typeLocks || [];
  }
}

function PisWorkspacesController(stateService, userService, toasterService, $translate, FileSaver, $uibModal) {
  const ctrl = this;

  ctrl.$onInit = async () => {
    ctrl.workspaces = [];
    getAllWorkspaces();
    ctrl.selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.hasDeploy = userService.hasPISDeploy();
    ctrl.hasApprove = userService.hasPISApprove();
    ctrl.hasEdit = userService.hasEditPIS();
    ctrl.sortType = 'name'; // set the default sort type
    ctrl.sortReverse = false; // set the default sort order
    ctrl.workspaceTooltip = 'Create more workspaces by cloning an existing one.';
    ctrl.stateDropdownOpen = false;
  };

  const getAllWorkspaces = () => {
    ctrl.dataLoading = true;
    stateService.getWorkspaces().then(workspaces => {
      ctrl.workspaces = workspaces;
      ctrl.dataLoading = false;

      // Update the selected workspace after the operation
      let selectedWp = ctrl.selectedWorkspace;
      if (selectedWp) {
        let updatedWorkspace = ctrl.workspaces.find(wp => wp.id === selectedWp.id);
        if (updatedWorkspace) {
          stateService.setSelectedWorkspace(updatedWorkspace);
          ctrl.onWorkspaceSelect({
            $event: {
              selectedWorkspace: updatedWorkspace,
            },
          });
        }
      }
    });
  };

  const findAllAudioStation = async (workspace) => {
    ctrl.fragments = await stateService.getFragments(workspace.id);
    const allAudioStation = ctrl.fragments.find(fragment => (fragment.all_audio_linked && fragment.fragment_type === 'STATION_ID'));
    stateService.setAllAudioStation(allAudioStation);
  };

  ctrl.togglePisLock = () => {
    ctrl.dataLoading = true;
    if (ctrl.pisLockStatus.lockOwner) {
      unlockPisTool();
    } else {
      lockPisTool();
    }
  };

  const unlockPisTool = () => {
    stateService.unlockPisTool().then(res => {
      if (res.statusCode === 200) {
        removeWorkspaceSelection();
        ctrl.pisLockStatus.lockOwner = null;
        ctrl.hasLock = false;
        ctrl.onPisLock({
          $event: {
            pisLockStatus: ctrl.pisLockStatus,
            hasLock: ctrl.hasLock,
          },
        });
        toasterService.success($translate.instant('toaster.pis-event'), $translate.instant('toaster.pis-unlock-successful'));
      } else {
        toasterService.error($translate.instant('toaster.pis-event'), $translate.instant('toaster.pis-unlock-failure'));
      }
      ctrl.dataLoading = false;
    });
  };

  const lockPisTool = () => {
    stateService.lockPisTool().then(res => {
      if (res.statusCode === 200) {
        ctrl.pisLockStatus.lockOwner = 'CURRENT USER PLACEHOLDER';
        ctrl.hasLock = true;
        ctrl.onPisLock({
          $event: {
            pisLockStatus: ctrl.pisLockStatus,
            hasLock: ctrl.hasLock,
          },
        });
        toasterService.success($translate.instant('toaster.pis-event'), $translate.instant('toaster.pis-lock-successful'));
      } else {
        toasterService.error($translate.instant('toaster.pis-event'), $translate.instant('toaster.pis-lock-failure'));
      }
      ctrl.dataLoading = false;
    });
  };

  ctrl.setSortType = column => {
    ctrl.sortType = column;
  };

  ctrl.setSortReverse = () => {
    ctrl.sortReverse = !ctrl.sortReverse;
  };

  ctrl.openDropdown = ($event, workspace) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (ctrl.selectedWorkspace && workspace && ctrl.selectedWorkspace.id !== workspace.id) {
      ctrl.setWorkspace($event, workspace)
    }
    ctrl.stateDropdownOpen = true
  }

  ctrl.openWorkspaceModal = ($event, mode, workspace) =>  {
    ctrl.stateDropdownOpen = false;
    let toasterLabel = $translate.instant('toaster.pis-event'); 

    if (mode === 'CREATE' && ctrl.workspaces.length > 0) return;
    $event.preventDefault();
    $event.stopPropagation();
    let modalInstance = $uibModal.open({
      component: 'workspaceModal',
      backdrop: 'static',
      resolve: {
        mode: function() {
          return mode;
        },
        workspace: function() {
          return angular.copy(workspace);
        },
      },
    });
    modalInstance.result.then(
      workspaceObject => {
        // User pressed 'Save' in the modal.
        if (workspaceObject.mode && workspaceObject.mode === 'DELETE') {
          stateService.deleteWorkspace(workspaceObject.id).then(
            function(response) {
              stateService.setSelectedWorkspace(null);
              ctrl.onWorkspaceSelect({
                $event: {
                  selectedWorkspace: null,
                },
              });
              getAllWorkspaces();
              toasterService.success(toasterLabel, $translate.instant('toaster.pis-delete-workspace-successful'));
            },
            function(e) {
              toasterService.error(toasterLabel, $translate.instant('toaster.pis-delete-workspace-failure'));
              console.log(e);
            }
          );
        } else if (workspaceObject.mode && workspaceObject.mode === 'CREATE') {
          ctrl.dataLoading = true;
          stateService.createWorkspace(workspaceObject.workspace).then(
            function(response) {
              ctrl.dataLoading = false;
              getAllWorkspaces();
              toasterService.success(toasterLabel, $translate.instant('toaster.pis-new-workspace-successful'));
            },
            function(e) {
              toasterService.error(toasterLabel, $translate.instant('toaster.pis-new-workspace-failure'));
              console.log(e);
            }
          );
        } else if (workspaceObject.mode && workspaceObject.mode === 'CLONE') {
          // CLONE
          stateService.cloneWorkspace(workspaceObject.workspace).then(
            function(response) {
              getAllWorkspaces();
              toasterService.success(toasterLabel, $translate.instant('toaster.pis-clone-workspace-successful'));
            },
            function(e) {
              toasterService.error(toasterLabel, $translate.instant('toaster.pis-clone-workspace-failure'));
              console.log(e);
            }
          );
        } else if (workspaceObject.mode && workspaceObject.mode === 'EDIT') {
          // EDIT
          stateService.editWorkspace(workspaceObject.workspace).then(
            function(response) {
              getAllWorkspaces();
              toasterService.success(toasterLabel, $translate.instant('toaster.pis-edit-workspace-successful'));
            },
            function(e) {
              toasterService.error(toasterLabel, $translate.instant('toaster.pis-edit-workspace-failure'));
              console.log(e);
            }
          );
        } else if (workspaceObject.mode && workspaceObject.mode === 'DATES') {
          // SET VALIDITY
          stateService.editWorkspaceDates(workspaceObject.id, workspaceObject.start, workspaceObject.end).then(
            function(response) {
              getAllWorkspaces();
              toasterService.success(toasterLabel, $translate.instant('toaster.pis-edit-workspace-successful'));
            },
            function(e) {
              toasterService.error(toasterLabel, $translate.instant('toaster.pis-edit-workspace-failure'));
              console.log(e);
            }
          );
        } else if (workspaceObject.mode && workspaceObject.mode === 'SET_DEPLOYABLE') {
          // SET DEPLOYABLE (== APPROVE)
          stateService.setDeployable(workspaceObject.workspace.id).then(
            function(response) {
              getAllWorkspaces();
              toasterService.success(toasterLabel, $translate.instant('toaster.pis-approve-workspace-successful'));
            },
            function(e) {
              toasterService.error(toasterLabel, $translate.instant('toaster.pis-approve-workspace-successful'));
              console.log(e);
            }
          );
        } else if (workspaceObject.mode && workspaceObject.mode === 'CANCEL_DEPLOYABLE') {
          // CANCEL DEPLOYABLE (== REVOKE)
            stateService.cancelDeployable(workspaceObject.workspace.id).then(() => {
              getAllWorkspaces();
              toasterService.success(toasterLabel, $translate.instant('toaster.pis-revoke-workspace-successful'));
            },
            function(e) {
              toasterService.error(toasterLabel, $translate.instant('toaster.pis-revoke-workspace-failure'));
              console.log(e);
            });
        } else if (workspaceObject.mode && workspaceObject.mode === 'DEPLOY') {
          // DEPLOY (== PUBLISH)
          ctrl.dataLoading = true;
          stateService.publishWorkspace(workspaceObject.workspace.id).then(function (response) {
            ctrl.dataLoading = false;
            if (response.statusCode === 200) {
              toasterService.success(toasterLabel, $translate.instant('toaster.pis-deploy-workspace-successful'));
            } else if (response.statusCode === 403) {
              toasterService.error(toasterLabel, $translate.instant('toaster.pis-deploy-workspace-logic-package-max-number-exist'));
            } else {
              toasterService.error(toasterLabel, $translate.instant('toaster.pis-deploy-workspace-failure'));
            }
          });
        }
      },
      () => {  
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.setWorkspace = ($event, selectedWorkspace) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (!ctrl.hasLock) return;
    if (ctrl.selectedWorkspace === selectedWorkspace) {
      removeWorkspaceSelection();
    } else {
      ctrl.stateDropdownOpen = false;
      stateService.setSelectedWorkspace(selectedWorkspace);
      findAllAudioStation(selectedWorkspace);
      ctrl.selectedWorkspace = stateService.getSelectedWorkspace();
      ctrl.onWorkspaceSelect({
        $event: {
          selectedWorkspace: selectedWorkspace,
        },
      });
    }
  };

  const removeWorkspaceSelection = () => {
    stateService.setSelectedWorkspace(null);
    ctrl.selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.onWorkspaceSelect({
      $event: {
        selectedWorkspace: null,
      },
    });
  };

  ctrl.exportCsv = ($event, workspace) => {
    $event.preventDefault();
    $event.stopPropagation();
    stateService.getWorkspaceSegmentStatus(workspace.id).then(
      function(response) {

        // Remove unnecessary segments. Manual AVI segments are filtered already in the backend.
        const filteredSegments = response.filter(s => s.segmentExists && s.required);
        filteredSegments.sort((a, b) => a.segmentId - b.segmentId);

        let csv = "ID;Type;Name;Description;Filename;Text;\n";

        for (let s of filteredSegments) {
          let segmentText = "";
          let audioFilename = "";
          if (s.type === "AUDIO") {
              // Generated filename depends on segment type: BEGIN, MIDDLE, END, INDEPENDENT
              // Naming pattern for files: the first letter of type + segment ID
              audioFilename = s.audioPosition.substring(0,1).toLowerCase() +  s.segmentId + ".mp3";
          } else if (s.type === "TEXT") {
            // Show textual context only for text segments. Remove line endings from the list.
            segmentText = s.segmentText.replace("\n", "");
          }

          let row = s.segmentId + ";"
                  + s.type + ";"
                  + s.segmentName.replace("\n", "") + ";"
                  + s.segmentDescription.replace("\n", "") + ";"
                  + audioFilename.replace("\n", "") + ";"
                  + segmentText + ";"
                  + "\n";
          
          csv += row;
        }
        let data = new Blob([csv], { type: 'text/csv' });
        let filename =  "PIS-Tool-Segments-" + workspace.name + ".csv";
        FileSaver.saveAs(data, filename);
        ctrl.stateDropdownOpen = false;
      },
    );
  }

  ctrl.exportManualAviList = ($event, workspace) => {
    $event.preventDefault();
    $event.stopPropagation();
    stateService.getSegments().then(
      function(response) {

        // Include only Manul AVIs in this list
        const filteredSegments = response.filter(s => s.offline);

        let csv = "Number;Name;Synopsis;Audio;Filename;\n";

        // Manual AVIs are dual segments combined with same number (1-99) 
        for (let i=1; i < 100; i++) {
          const audioSegment = filteredSegments.find(s => s.number === i && s.stream_type === "AUDIO");
          const textSegment = filteredSegments.find(s => s.number === i && s.stream_type === "TEXT");

          let segmentId = i;
          if (i < 10) {
            segmentId = "0" + segmentId;
          }

          let row = segmentId + ";"
          + textSegment.name.replace("\n", "") + ";"
          + textSegment.description.replace("\n", "") + ";"
          + textSegment.text.replace("\n", "") + ";"
          + audioSegment.filename + ";"
          + "\n";
        
          csv += row;
        }

        let data = new Blob([csv], { type: 'text/csv' });
        let filename =  "PIS-Tool-Manual-AVIs-" + workspace.name + ".csv";
        FileSaver.saveAs(data, filename);
        ctrl.stateDropdownOpen = false;
      },
    );
  }

  ctrl.refreshDurations = ($event, workspace) => {
    // prevent the user to perform the operation again if the operation is in progress
    if (ctrl.dataLoading) {
      console.error("Operation already in progress.");
      return;
    }  
    ctrl.dataLoading = true;
    let toasterLabel = $translate.instant('toaster.pis-event'); 
    $event.preventDefault();
    $event.stopPropagation();
    stateService.fixWorkspaceAudioFiles(workspace.id).then(
      function(response) {
        toasterService.success(toasterLabel, $translate.instant('toaster.pis-fix-workspace-files-successful'));
        ctrl.dataLoading = false;
        ctrl.stateDropdownOpen = false;
      },
      function(e) {
        ctrl.dataLoading = false;
        toasterService.error(toasterLabel, $translate.instant('toaster.pis-fix-workspace-files-failure'));
        console.log(e);
        ctrl.stateDropdownOpen = false;
      }
    );
  }
}

angular
    .module('pis-tool.module')
    .controller('PisWorkspacesController', PisWorkspacesController);
